/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Upload_PasteInputs */

const en_homepage_features_upload_paste = /** @type {(inputs: Homepage_Features_Upload_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Text`)
};

const es_homepage_features_upload_paste = /** @type {(inputs: Homepage_Features_Upload_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar texto`)
};

/**
* | output |
* | --- |
* | "Paste Text" |
*
* @param {Homepage_Features_Upload_PasteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_upload_paste = /** @type {((inputs?: Homepage_Features_Upload_PasteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Upload_PasteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_upload_paste(inputs)
	return en_homepage_features_upload_paste(inputs)
});